import Widget from 'Components/Common/Widget/Widget';
import React, { useEffect, useState } from 'react';
import { BiSolidCoupon } from 'react-icons/bi';
import { BsFillStopwatchFill } from 'react-icons/bs';
import { TbStarsFilled } from "react-icons/tb";
import ListOfPromocodes from './components/ListOfPromocodes';
import { getAllPromocode } from 'Common Usage/apiService';
import AddPromoCodeForm from './components/AddPromoCodeForm';

const ManagePromoCode = () => {
  const [promos, setPromos] = useState([]);
  const [userDataLoading, setUserDataLoading] = useState(true);
  const [addPromoCodeModal, setAddPromoCodeModal] = useState(false);

  useEffect(() => {
    fetchPromos();
  }, []);

  const fetchPromos = async () => {
    try {
      const data = await getAllPromocode();
      setPromos(data);
    } catch (error) {
      console.log("getAllPromos-Error", error);
    } finally {
      setUserDataLoading(false);
    }
  };

  // Calculate the counts for special and hourly promo codes
  const specialPromoCount = promos.filter(promo => promo.promoType === "special").length;
  const hourlyPromoCount = promos.filter(promo => promo.promoType === "hour-basis").length;


  const handleAddModalOpen = () => {
    setAddPromoCodeModal(true);
  }

  const handleAddModalClose = () => {
    setAddPromoCodeModal(false);
  }


  return (
    <React.Fragment>
      <AddPromoCodeForm
        addPromoCodeModal={addPromoCodeModal}
        handleAddModalClose={handleAddModalClose}
        fetchPromos={fetchPromos}
      />

      <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-6">
        <Widget
          icon={<BiSolidCoupon className="h-6 w-6" />}
          title={"Our Total Promo Codes"}
          subtitle={promos?.length}
        />
        <Widget
          icon={<TbStarsFilled className="h-6 w-6" />}
          title={"No. of Special Promo Codes"}
          subtitle={specialPromoCount}
        />
        <Widget
          icon={<BsFillStopwatchFill className="h-6 w-6" />}
          title={"No. of Hourly Promo Codes"}
          subtitle={hourlyPromoCount}
        />
      </div>

      <ListOfPromocodes
        promos={promos}
        userDataLoading={userDataLoading}
        handleAddModalOpen={handleAddModalOpen}
        fetchPromos={fetchPromos}
      />
    </React.Fragment>
  );
}

export default ManagePromoCode;











// import Widget from 'Components/Common/Widget/Widget';
// import React, { useEffect, useState } from 'react';
// import { BiSolidCoupon } from 'react-icons/bi';
// import { BsFillStopwatchFill } from 'react-icons/bs';
// import { TbStarsFilled } from "react-icons/tb";
// import ListOfPromocodes from './components/ListOfPromocodes';
// import { getAllPromocode } from 'Common Usage/apiService';

// const ManagePromoCode = () => {
//   const [promos, setPromos] = useState([]);
//   const [userDataLoading, setUserDataLoading] = useState(true);

//   useEffect(() => {
//     const fetchPromos = async () => {
//       try {
//         const data = await getAllPromocode();
//         setPromos(data);
//       } catch (error) {
//         console.log("getAllPromos-Error", error);
//       } finally {
//         setUserDataLoading(false);
//       }
//     };
//     fetchPromos();
//   }, []);

//   return (
//     <React.Fragment>
//       <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-6">
//         <Widget
//           icon={<BiSolidCoupon className="h-6 w-6" />}
//           title={"Our Total Promo Codes"}
//           subtitle={promos?.length}
//         />
//         <Widget
//           icon={<TbStarsFilled className="h-6 w-6" />}
//           title={"No. of Special Promo Codes"}
//           subtitle={"34"}
//         />
//         <Widget
//           icon={<BsFillStopwatchFill className="h-6 w-6" />}
//           title={"No. of Hourly Promo Codes"}
//           subtitle={"23"}
//         />
//       </div>

//       <ListOfPromocodes
//         promos={promos}
//         userDataLoading={userDataLoading}
//       />
//     </React.Fragment>
//   )
// }

// export default ManagePromoCode
